import { useEffect, useState } from 'react';
import { Button, IconButton, Stack, SvgIcon, Typography, Container, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logoBlack from '../../assets/logo-black.png';
const navGroups = [
  {
    label: 'ראשי',
    pages: [
      {
        id: 'overview',
        label: 'סקירה',
        description: 'מבט מהיר',
        icon: 'overview',
      },
      {
        id: 'categories',
        label: 'קטגוריות',
        description: 'מיפוי קטגוריות Google',
        icon: 'categories',
      },
      {
        id: 'appUsers',
        label: 'משתמשים',
        description: 'משתמשי האפליקציה',
        icon: 'users',
      },
    ],
  },
  {
    label: 'מקומות',
    pages: [
      {
        id: 'places',
        label: 'מקומות',
        description: 'רשימה ועריכה',
        icon: 'places',
      },
      {
        id: 'complexes',
        label: 'מתחמים וקניונים',
        description: 'רשימת מתחמים',
        icon: 'complexes',
      },
      {
        id: 'osmImport',
        label: 'ייבוא מ־OpenStreetMap',
        description: 'Preview וייבוא מקומות',
        icon: 'places',
      },
      {
        id: 'placeEdits',
        label: 'הצעות עריכה',
        description: 'אישור שינויים מהאתר',
        icon: 'issues',
      },
    ],
  },
  {
    label: 'דיווחים',
    pages: [
      {
        id: 'reports',
        label: 'דיווחים',
        description: 'כל דיווחי העומס',
        icon: 'reports',
      },
      {
        id: 'gpsRawReports',
        label: 'דיווחי GPS',
        description: 'נתוני GPS גולמיים',
        icon: 'gps',
      },
      {
        id: 'autoVisitReports',
        label: 'דיווחים אוטומטיים',
        description: 'תהליך Auto Visit ואבחון תקלות',
        icon: 'gps',
      },
      {
        id: 'autoVisitSettings',
        label: 'הגדרות דיווח אוטומטי',
        description: 'Auto Visit ו־Geofence',
        icon: 'settings',
      },
      {
        id: 'placeIssues',
        label: 'דיווחי מקום',
        description: 'תקלות ועדכוני מידע',
        icon: 'issues',
      },
    ],
  },
  {
    label: 'אלגוריתם',
    pages: [
      {
        id: 'loadAlgorithm',
        label: 'אלגוריתם עומס',
        description: 'משקלים וכיוונונים',
        icon: 'algorithm',
      },
      {
        id: 'aiAlgorithm',
        label: 'אלגוריתם AI',
        description: 'פרומפט, הקשר ובדיקות',
        icon: 'ai',
      },
      {
        id: 'gpsSettings',
        label: 'הגדרות GPS',
        description: 'סיווג וחישוב עומס',
        icon: 'settings',
      },
    ],
  },
  {
    label: 'מערכת',
    pages: [
      {
        id: 'analytics',
        label: 'אנליטיקס',
        description: 'אירועים וסינונים',
        icon: 'analytics',
      },
      {
        id: 'logs',
        label: 'לוגים',
        description: 'שגיאות ואירועי מערכת',
        icon: 'logs',
      },
    ],
  },
];
const icons = {
  overview: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
    </>
  ),
  places: (
    <>
      <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  complexes: (
    <>
      <path d="M3 21h18M5 21V8l7-5 7 5v13M8 11h2M14 11h2M8 15h2M14 15h2M10 21v-3h4v3" />
    </>
  ),
  categories: (
    <>
      <path d="M4 6h16M4 12h16M4 18h16" />
      <circle cx="7" cy="6" r="1" />
      <circle cx="7" cy="12" r="1" />
      <circle cx="7" cy="18" r="1" />
    </>
  ),
  users: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  reports: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" />
      <path d="M8 7h8M8 11h6" />
    </>
  ),
  gps: (
    <>
      <path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" />
      <circle cx="12" cy="10" r="2" />
      <path d="M3 4h3M18 4h3M3 20h3M18 20h3" />
    </>
  ),
  issues: (
    <>
      <path d="M10.3 2.9 1.8 17a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 2.9a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9v4M12 17h.01" />
    </>
  ),
  analytics: (
    <>
      <path d="M3 3v18h18" />
      <path d="m7 16 4-5 4 3 5-7" />
    </>
  ),
  logs: (
    <>
      <path d="M4 4h16v16H4z" />
      <path d="M8 9h8M8 13h8M8 17h5" />
    </>
  ),
  algorithm: (
    <>
      <path d="M4 18V9M10 18V5M16 18v-7M22 18V2" />
      <path d="M2 22h22" />
    </>
  ),
  ai: (
    <>
      <path d="M9 3h6M12 3v3M5 8h14v11H5z" />
      <circle cx="9" cy="13" r="1" />
      <circle cx="15" cy="13" r="1" />
      <path d="M9 17h6M2 12h3M19 12h3" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M4 12a8 8 0 0 1 .2-1.8l-2-1.5 2-3.4 2.4 1a8 8 0 0 1 3-1.7L10 2h4l.4 2.6a8 8 0 0 1 3 1.7l2.4-1 2 3.4-2 1.5A8 8 0 0 1 20 12a8 8 0 0 1-.2 1.8l2 1.5-2 3.4-2.4-1a8 8 0 0 1-3 1.7L14 22h-4l-.4-2.6a8 8 0 0 1-3-1.7l-2.4 1-2-3.4 2-1.5A8 8 0 0 1 4 12Z" />
    </>
  ),
};
const NavIcon = ({ name }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{
      width: '21px',
      height: '21px',
    }}
  >
    {icons[name]}
  </SvgIcon>
);
const AppLayout = ({ activeTab, onTabChange, user, onLogout, children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const initials = (user?.name || 'L').trim().slice(0, 2).toUpperCase();
  useEffect(() => setMenuOpen(false), [activeTab]);
  return (
    <Container
      dir="rtl"
      maxWidth={false}
      disableGutters
      sx={{
        height: '100dvh',
        minHeight: 0,
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', lg: '286px minmax(0, 1fr)' },
        gridTemplateRows: { xs: '64px minmax(0, 1fr)', lg: 'minmax(0, 1fr)' },
        gridTemplateAreas: { xs: '"header" "main"', lg: '"sidebar main"' },
        direction: 'rtl',
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          gridArea: 'header',
          display: { xs: 'flex', lg: 'none' },
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 18px',
          background: '#fff',
          borderBottom: '1px solid var(--line)',
          zIndex: 31,
        }}
      >
        <Box
          component="img"
          src={logoBlack}
          alt="Calmpi"
          sx={{
            display: 'block',
            width: {
              xs: 100,
              sm: 106,
            },
            height: 'auto',
            objectFit: 'contain',
          }}
        />

        <IconButton
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((value) => !value)}
          sx={{
            color: 'text.primary',
          }}
        >
          <MenuIcon />
        </IconButton>
      </Stack>

      <Stack
        sx={{
          gridArea: 'sidebar',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: { xs: '14px', lg: '32px' },
          height: '100dvh',
          minHeight: 0,
          padding: 1,
          background: { xs: '#fff', lg: 'rgba(255,255,255,.92)' },
          color: '#15211f',
          textAlign: 'right',
          overflow: 'hidden',
          position: { xs: 'fixed', lg: 'relative' },
          zIndex: { xs: 40, lg: 'auto' },
          top: { xs: 0, lg: 'auto' },
          right: { xs: 0, lg: 'auto' },
          bottom: { xs: 0, lg: 'auto' },
          width: { xs: 'min(320px, 88vw)', lg: 'auto' },
          transform: { xs: menuOpen ? 'translateX(0)' : 'translateX(105%)', lg: 'none' },
          transition: { xs: 'transform .22s ease', lg: 'none' },
          borderLeft: '1px solid rgba(20,45,41,.1)',
          boxShadow: { xs: '-18px 0 48px rgba(15,23,42,.2)', lg: '-8px 0 32px rgba(17,39,35,.06)' },
        }}
      >
        <Stack
          sx={(theme) => ({
            overflow: 'hidden',
            [theme.breakpoints.down('lg')]: {
              minWidth: '0',
              display: 'grid',
              alignItems: 'stretch',
              gap: '18px',
            },
          })}
        >
          <Box
            component="img"
            src={logoBlack}
            alt="Calmpi"
            sx={{
              display: 'block',
              width: {
                xs: 100,
                sm: 120,
              },
              height: 'auto',
              objectFit: 'contain',
              my: {
                xs: 0,
                sm: 1,
              },
            }}
          />

          <Stack
            aria-label="ניווט ראשי"
            sx={(theme) => ({
              minHeight: '0',
              overflowY: 'auto',
              paddingLeft: '4px',
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(22, 119, 255, .3) transparent',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '999px',
                background: 'rgba(22, 119, 255, .3)',
              },
              display: 'grid',
              gap: '6px',
              '& button': {
                background: 'transparent',
                color: '#455064',
                border: '0',
                textAlign: 'right',
                display: 'grid',
                gap: '13px',
                minHeight: '58px',
                alignContent: 'center',
                gridTemplateColumns: '22px minmax(0, 1fr)',
                alignItems: 'center',
                padding: '9px 12px',
                borderRadius: '13px',
              },
              '& button small': {
                color: '#7d8794',
                fontWeight: '500',
                fontSize: '11px',
              },
              [theme.breakpoints.down('lg')]: {
                minWidth: '0',
                flex: '1',
                display: 'grid',
                gap: '8px',
                overflowX: 'hidden',
                overflowY: 'auto',
                paddingBottom: '2px',
                scrollbarWidth: 'thin',
                '& button': {
                  minWidth: '0',
                  minHeight: '44px',
                  padding: '8px 12px',
                  display: 'grid',
                  gridTemplateColumns: '22px minmax(0,1fr)',
                  justifyContent: 'stretch',
                },
                '& button small': {
                  display: 'grid',
                },
              },
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                '& button': {
                  minWidth: '48px',
                  justifyContent: 'center',
                },
                '& button small': {
                  display: 'none',
                },
              },
              '& button:hover': {
                background: '#eef5ff',
                color: '#1269e8',
              },
            })}
          >
            {navGroups.map((group) => (
              <Stack
                key={group.label}
                aria-label={group.label}
                sx={(theme) => ({
                  display: 'grid',
                  gap: '5px',
                  marginTop: '10px',
                  paddingTop: '10px',
                  borderTop: '1px solid rgba(20, 45, 41, .08)',
                  [theme.breakpoints.down(761)]: {
                    marginTop: '0',
                    paddingTop: '0',
                    borderTop: '0',
                  },
                })}
              >
                <Typography
                  sx={(theme) => ({
                    fontSize: 12,
                    textAlign: 'center',
                    color: 'primary.main',
                    fontWeight: 'bold',
                    [theme.breakpoints.down(761)]: {
                      display: 'none',
                    },
                  })}
                >
                  {group.label}
                </Typography>

                <Stack>
                  {group.pages.map((page) => (
                    <Button
                      key={page.id}
                      onClick={() => {
                        onTabChange(page.id);
                        setMenuOpen(false);
                      }}
                    >
                      <NavIcon name={page.icon} />

                      <Stack>
                        <Typography>{page.label}</Typography>
                        <Typography
                          sx={{
                            fontSize: 11,
                          }}
                          color="text.secondary"
                        >
                          {page.description}
                        </Typography>
                      </Stack>
                    </Button>
                  ))}
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>

        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
            padding: '13px 10px',
            border: '1px solid rgba(20,45,41,.1)',
            borderRadius: '14px',
            background: '#f7f9f8',
          }}
        >
          <Stack>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 'bold',
              }}
            >
              {user?.name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
              }}
            >
              {user?.email || 'מנהל מערכת'}
            </Typography>
          </Stack>

          <Button
            onClick={onLogout}
            sx={{
              background: 'transparent',
              color: '#7d8794',
              fontSize: '18px',
            }}
          >
            ↗
          </Button>
        </Stack>
      </Stack>

      <Stack
        sx={{
          gridArea: 'main',
          minWidth: '0',
          minHeight: '0',
          padding: {
            xs: 1,
            sm: 2,
          },
          position: 'relative',
          direction: 'rtl',
          textAlign: 'right',
          overflowY: 'auto',
          overflowX: 'hidden',
          bgcolor: 'background.default',
        }}
      >
        {children}
      </Stack>
    </Container>
  );
};
export default AppLayout;
